<script lang="ts">
    import {Component, toNative, Vue} from 'vue-facing-decorator'
    import HotelSearchSummary from '~/components/search/HotelSearchSummary.vue'
    import PackagesSearchForm from '~/components/packages/search/forms/PackagesSearchForm.vue'

    @Component({
        components: {PackagesSearchForm},
        mixins: [HotelSearchSummary],
    })
    export class PackagesSearchSummary extends Vue {
        get isSearchActive() {
            return packagesRuntimeStore.searchActive
        }

        get rooms() {
            return []
        }

        get searchFormComponent() {
            return resolveComponent('PackagesSearchForm')
        }

        get locationLabel() {
            if (!packagesRuntimeStore.arrivalPoint || !packagesRuntimeStore.departurePoint) return null
            return `${packagesRuntimeStore.departurePoint.name}, ${packagesRuntimeStore.departurePoint.countryName} - ${packagesRuntimeStore.arrivalPoint.name}, ${packagesRuntimeStore.arrivalPoint.countryName}`
        }

        get touristsTotal() {
            return this.searchRequest.adults + this.searchRequest.childrenAges.length
        }
    }

    export default {...toNative(PackagesSearchSummary), ssrRender: HotelSearchSummary.ssrRender}
</script>
